module.exports = __webpack_public_path__ + "static/media/logo-left-lg.c92f80f7.png";